const Emoji_L = {
    ':lac': { id: 321, width: 24, height: 24 },
    ':lady': { id: 322, width: 19, height: 25 },
    ':lamer': { id: 323, width: 49, height: 24 },
    ':laugh_1': { id: 324, width: 20, height: 20 },
    ':laugh': { id: 325, width: 18, height: 18 },
    ':licklips': { id: 326, width: 25, height: 25 },
    ':lips': { id: 327, width: 23, height: 15 },
    ':lmao1': { id: 328, width: 16, height: 16 },
    ':lock': { id: 329, width: 32, height: 23 },
    ':lol_1': { id: 330, width: 20, height: 20 },
    ':lol': { id: 325, width: 18, height: 18 },
    ':lol1': { id: 331, width: 16, height: 16 },
    ':lookaround': { id: 333, width: 20, height: 20 },
    ':lu': { id: 334, width: 40, height: 24 },
}

export default Emoji_L
